<template>
  <v-container class="fill-height d-flex"  fluid>
   <Loader :esActiva="mostrar_loader"/>
    <v-row class="d-flex justify-center">
        <v-form v-model="valido" ref="form">
        <v-col sm=12 v-if="usuario.validacion =='correo'">
        <p>Ingresa nuevamente tu cuenta de correo electrónico</p>
          <v-text-field
            v-model="correo"
            label="CORREO ELECTRÓNICO"
            class="py-4"
            :rules="[v => !!v || 'No ha ingresado el correo electrónico',rules.email]"
            placeholder="CORREO ELECTRÓNICO"
            prepend-inner-icon="mdi-email"
            solo
            onkeypress="return event.charCode !== 13"
          ></v-text-field>
        </v-col>
        <v-col sm=12 v-else>
        <p>Ingresa nuevamente tu número celular</p>
          <v-text-field
            v-model="telefono"
            label="CELULAR"
            class="py-4"
            type="tel"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            placeholder="CELULAR"
            prepend-inner-icon="mdi-phone-outline"
            solo
            :rules="[v => !!v || 'No ha ingresado el número CELULAR', rules.telefono]"
          ></v-text-field>
        </v-col>   
        </v-form>                         
    </v-row>
   
    <v-footer absolute class="font-weight-medium" padless>
      <v-btn x-large color="#58C4B5" dark style="width: 100%;"
       @click="reenviar()">REENVIAR</v-btn>
    </v-footer>
  </v-container>  
</template>

<script>
import Usuario from "@/objetos/usuario";
import Conexion_api from "@/api/Conexion_api.js";
import Loader from '@/components/Loader/Loader.vue';

export default {
  components: {    
    Loader
  },
  data: () => ({
    usuario:Usuario,    
    rules: {
      email: value => {
        if(!value) return true 
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Email invalido.'
      },
      telefono: value => {
        if(!value) return true
        return value.length >= 9 || 'El CELULAR debe tener mínimo 9 dígitos.'
      }
    },
    valido: false,
    correo:"",
    telefono: "",
    correo_valido:false,
    error_debounce: "",
    mostrar_loader: false
  }),
  methods:{
    reenviar(){
      /*Se comento porque queda para segunda fase validar correo debounce*/
      //if(this.usuario.validacion =='correo' && !this.correo_valido) return;
      if( this.$refs.form.validate()){
        if(this.usuario.validacion == 'correo'){
          this.usuario.correo = this.correo
        }else{
          this.usuario.telefono = this.telefono
        }
        Conexion_api({
          body: {
            ...this.usuario
          },
          evento: "login/enviar_codigo"
        })
          .then(respuesta => {
            this.mostrar_loader = false;
            if (respuesta.data.error) {
              console.error(respuesta.data.error);
              this.$root.$emit('snackbar',{ color:"error", texto: respuesta.data.error})   
              return;
            } else if (respuesta.data.exito) {
              this.$root.$emit('snackbar',{ 
                color:"green",
                texto: "Se ha enviado  un código de verificación." })   
              this.$router.push("/verificar");
            }
          })
          .catch(err => {
            this.mostrar_loader = false;
            err = String(err);
            console.error(err);
          });
      }
    },
    validar_correo(){
      if(!this.correo) return;      
      this.mostrar_loader = true;
      Conexion_api({
          body: {
              correo: this.correo
          },
          evento: "login/validar_correo_debounce"
      }).then(respuesta => {   
          this.mostrar_loader = false;            
          if(!respuesta.data.datos.valido) this.error_debounce = 'Email invalido.'  
          else this.error_debounce = ""; 
          if(respuesta.data.error){                     
            this.$root.$emit('snackbar',{ color:"error", texto: respuesta.data.error})
            return;
          }           
          this.correo_valido = respuesta.data.datos.valido;
      }).catch(err => { 
      this.mostrar_loader = false;     
        err = String(err)
        this.$root.$emit('snackbar',{ color:"error", texto: err})                   
        console.error(err)
      }) 
    } 
    
  }

}
</script>

